import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { handleCta } from 'bv-services';

import BannerImg from './banner_img';
import HeartbingoBannerImg from './heartbingo_banner_img';

const BannerItem = ({
  banner,
  isActive,
  nextItem,
  prevItem,
  isPrevious,
  isFirst,
  bannerIndex,
}) => (
  // eslint-disable-next-line jsx-a11y/no-static-element-interactions
  <div
    style={banner.outer_background_color && { backgroundColor: banner.outer_background_color }}
    className={classnames('bv-slider-item', `bv-slider-item--${bannerIndex}`, {
      'is-clickable': banner.cta.action.length,
      'is-next-item': isActive && nextItem,
      'is-prev-item': isActive && prevItem,
      'is-previous': isPrevious,
      'is-first': isFirst,
    })}
    onClick={() => handleCta(banner.cta)}
  >
    {
      banner?.type === 'LayoutB' ? (
        <HeartbingoBannerImg
          bgUrl={banner.hero_background_image}
          textUrl={banner.hero_text_image}
        />
      ) : (
        <>
          <BannerImg
            bgUrl={banner.small_responsive_image.background}
            textUrl={banner.small_responsive_image.text}
            bannerSize="small"
          />
          <BannerImg
            bgUrl={banner.large_responsive_image.background}
            textUrl={banner.large_responsive_image.text}
            bannerSize="large"
          />
        </>
      )
    }
  </div>
);

BannerItem.propTypes = {
  isPrevious: PropTypes.bool.isRequired,
  isActive: PropTypes.bool.isRequired,
  isFirst: PropTypes.bool.isRequired,
  nextItem: PropTypes.bool.isRequired,
  prevItem: PropTypes.bool.isRequired,
  banner: PropTypes.instanceOf(Object).isRequired,
  bannerIndex: PropTypes.number.isRequired,
};

export default BannerItem;
